import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import Skeleton from 'components/Skeleton';
import SkeletonCircle from 'components/SkeletonCircle';

import ItemGrid from '../ItemGrid';
import UpsellCard from '../UpsellCard';

const ITEMS_COUNT = 5;

export const BlurryUpsellCard: FC = () => (
  <Box position="relative">
    <Box
      left="10%"
      position="absolute"
      right="10%"
      top="50%"
      transform="translate(0%, -50%)"
      zIndex={1}
    >
      <UpsellCard hasItems />
    </Box>

    <SunshineCard.Group>
      {[...Array(ITEMS_COUNT).keys()].map((key) => (
        <SunshineCard key={key}>
          <ItemGrid>
            <SunshineCard.Content>
              <Skeleton height="20px" width="75%" />
              <Skeleton height="40px" width="100%" />
            </SunshineCard.Content>

            <Skeleton height="20px" />

            <Skeleton height="20px" />

            <Skeleton height="20px" />

            <SkeletonCircle margin="auto" />
          </ItemGrid>
        </SunshineCard>
      ))}
    </SunshineCard.Group>
  </Box>
);
